// 活动统一分享配置：路由守卫按 meta.share 自动写入
const activityShare = {
  link: location.origin + import.meta.env.BASE_URL + 'kepuyue-vote',
  title: '全国科普月“最具网络人气”线上投票评选活动',
  desc: '科技改变生活 创新赢得未来',
  img: 'https://pqnoss.kepuchina.cn/2024/01/12/16/195746/de4d80.png',
  isShareImage: 0,
};

/** 三个路由统一用活动全称做标题 */
const PAGE_TITLE = '全国科普月“最具网络人气”线上投票评选活动';

const routes = [
  {
    path: '/kepuyue-vote',
    name: 'kepuyue-vote',
    component: () => import('@/views/kepuyue-vote/IndexView.vue'),
    meta: {
      title: PAGE_TITLE,
      keepAlive: true,
      share: activityShare,
    },
  },
  {
    path: '/kepuyue-vote/detail',
    name: 'kepuyue-vote-detail',
    component: () => import('@/views/kepuyue-vote/DetailView.vue'),
    meta: {
      title: PAGE_TITLE,
      share: activityShare,
    },
  },
  {
    path: '/kepuyue-vote/rule',
    name: 'kepuyue-vote-rule',
    component: () => import('@/views/kepuyue-vote/RuleView.vue'),
    meta: {
      title: PAGE_TITLE,
      share: activityShare,
    },
  },
];
export default routes;
